import { ReactComponent as AddCircle } from "../assets/icons/add_circle.svg";
import { ReactComponent as AddPhotoAlternate } from "../assets/icons/add_photo_alternate.svg";
import { ReactComponent as Add } from "../assets/icons/add.svg";
import { ReactComponent as Apple } from "../assets/icons/apple.svg";
import { ReactComponent as ArrowBottom } from "../assets/icons/arrow_bottom.svg";
import { ReactComponent as ArrowCircleLeft } from "../assets/icons/arrow_circle_left.svg";
import { ReactComponent as ArrowTop } from "../assets/icons/arrow_top.svg";
import { ReactComponent as Cancel } from "../assets/icons/cancel.svg";
import { ReactComponent as CheckCircle } from "../assets/icons/check_circle.svg";
import { ReactComponent as CloudDownload } from "../assets/icons/cloud_download.svg";
import { ReactComponent as CloudUpload } from "../assets/icons/cloud_upload.svg";
import { ReactComponent as DeleteSweep } from "../assets/icons/delete_sweep.svg";
import { ReactComponent as Delete } from "../assets/icons/delete.svg";
import { ReactComponent as DragIndicator } from "../assets/icons/drag_indicator.svg";
import { ReactComponent as FormatListBulleted } from "../assets/icons/format_list_bulleted.svg";
import { ReactComponent as Google } from "../assets/icons/google.svg";
import { ReactComponent as ImageNotSupported } from "../assets/icons/image-not-supported.svg";
import { ReactComponent as KeyboardArrowDown } from "../assets/icons/keyboard_arrow_down.svg";
import { ReactComponent as KeyboardArrowUp } from "../assets/icons/keyboard_arrow_up.svg";
import { ReactComponent as KeyboardDoubleArrowDown } from "../assets/icons/keyboard_double_arrow_down.svg";
import { ReactComponent as KeyboardDoubleArrowRight } from "../assets/icons/keyboard_double_arrow_right.svg";
import { ReactComponent as KeyboardDoubleArrowUp } from "../assets/icons/keyboard_double_arrow_up.svg";
import { ReactComponent as LanguageEn } from "../assets/icons/language-en.svg";
import { ReactComponent as LanguageJa } from "../assets/icons/language-ja.svg";
import { ReactComponent as LanguageZh } from "../assets/icons/language-zh.svg";
import { ReactComponent as Login } from "../assets/icons/login.svg";
import { ReactComponent as Logout } from "../assets/icons/logout.svg";
import { ReactComponent as ManageAccounts } from "../assets/icons/manage_accounts.svg";
import { ReactComponent as PlayCircle } from "../assets/icons/play_circle.svg";
import { ReactComponent as PauseCircle } from "../assets/icons/pause_circle.svg";
import { ReactComponent as RemoveCircle } from "../assets/icons/remove_circle.svg";
import { ReactComponent as RestartAlt } from "../assets/icons/restart_alt.svg";
import { ReactComponent as Settings } from "../assets/icons/settings.svg";
import { ReactComponent as SkipNextCircle } from "../assets/icons/skip_next_circle.svg";
import { ReactComponent as SkipPreviousCircle } from "../assets/icons/skip_previous_circle.svg";
import { ReactComponent as Timer } from "../assets/icons/timer.svg";
import { ReactComponent as Translate } from "../assets/icons/translate.svg";
import { ReactComponent as VolumeOff } from "../assets/icons/volume_off.svg";
import { ReactComponent as VolumeUp } from "../assets/icons/volume_up.svg";

const Icon = {
  AddCircle: () => <AddCircle className="icon" />,
  AddPhotoAlternate: () => <AddPhotoAlternate className="icon" />,
  Add: () => <Add className="icon" />,
  Apple: () => <Apple className="icon" />,
  ArrowBottom: () => <ArrowBottom className="icon" />,
  ArrowCircleLeft: () => <ArrowCircleLeft className="icon" />,
  ArrowTop: () => <ArrowTop className="icon" />,
  Cancel: () => <Cancel className="icon" />,
  CheckCircle: () => <CheckCircle className="icon" />,
  CloudDownload: () => <CloudDownload className="icon" />,
  CloudUpload: () => <CloudUpload className="icon" />,
  DeleteSweep: () => <DeleteSweep className="icon" />,
  Delete: () => <Delete className="icon" />,
  DragIndicator: () => <DragIndicator className="icon" />,
  FormatListBulleted: () => <FormatListBulleted className="icon" />,
  Google: () => <Google className="icon" />,
  ImageNotSupported: () => <ImageNotSupported className="icon" />,
  KeyboardArrowDown: () => <KeyboardArrowDown className="icon" />,
  KeyboardArrowUp: () => <KeyboardArrowUp className="icon" />,
  KeyboardDoubleArrowDown: () => <KeyboardDoubleArrowDown className="icon" />,
  KeyboardDoubleArrowRight: () => <KeyboardDoubleArrowRight className="icon" />,
  KeyboardDoubleArrowUp: () => <KeyboardDoubleArrowUp className="icon" />,
  Login: () => <Login className="icon" />,
  Logout: () => <Logout className="icon" />,
  LanguageEn: () => <LanguageEn className="icon" />,
  LanguageJa: () => <LanguageJa className="icon" />,
  LanguageZh: () => <LanguageZh className="icon" />,
  ManageAccounts: () => <ManageAccounts className="icon" />,
  PlayCircle: () => <PlayCircle className="icon" />,
  PauseCircle: () => <PauseCircle className="icon" />,
  RemoveCircle: () => <RemoveCircle className="icon" />,
  RestartAlt: () => <RestartAlt className="icon" />,
  Settings: () => <Settings className="icon" />,
  SkipNextCircle: () => <SkipNextCircle className="icon" />,
  SkipPreviousCircle: () => <SkipPreviousCircle className="icon" />,
  Timer: () => <Timer className="icon" />,
  Translate: () => <Translate className="icon" />,
  VolumeOff: () => <VolumeOff className="icon" />,
  VolumeUp: () => <VolumeUp className="icon" />,
};

export default Icon;
